import React, { useState } from "react";
import "./NotificationBanner.css";

interface NotificationBannerProps {
  message: string;
  type?: "info" | "success" | "warning" | "error";
  dismissible?: boolean;
  onDismiss?: () => void;
}

export default function NotificationBanner({
  message,
  type = "info",
  dismissible = true,
  onDismiss,
}: NotificationBannerProps) {
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  if (!isVisible) return null;

  return (
    <div className={`notification-banner notification-${type}`}>
      <div className="notification-content">
        <p>{message}</p>
      </div>
      {dismissible && (
        <button
          className="notification-close"
          onClick={handleDismiss}
          aria-label="Close notification"
        >
          ✕
        </button>
      )}
    </div>
  );
}
